import React from "react";
import { Table } from "semantic-ui-react";
import DeviceLabel from "app/ui/pages/monitor/DeviceLabel";
import CylinderLabel from "app/ui/pages/monitor/CylinderLabel";
import "./MonitorTableHeader.scss";

const MonitorTableHeader = ({ account, isSalvusUser }) => {
    const columns = [
    {
      id: 1,
      content: "TIPO",
      width: 1,
      textAlign: "center"
    },
    {
      id: 2,
      content: "PACIENTE",
      width: 3,
      textAlign: "center"
    },
    {
      id: 3,
      content: "MAPA", 
      width: 1,
      textAlign: "center"
    },
    {
      id: 4,
      content: (
        <>
          <p>Prescrição</p>
          <p className="lowercase italic">(l/min)</p>
        </>
      ),
      width: 1,
      textAlign: "center",
    },
    {
      id: 5,
      content: (
        <>
          <p>FLUXO</p>
          <p className="lowercase italic">(l/min)</p>
        </>
      ),
      width: 1,
      textAlign: "center",
    },
    { 
      id: 6,
      content: "TÉRMINO",
      width: 1,
      textAlign: "center"
    },
    {
      id: 7,
      content: (
        <>
          DISPOSITIVO <span>(status)</span> <DeviceLabel />
        </>
      ),
      width: 1,
      textAlign: "center",
    },
    {
      id: 8,
      content: (
        <>
          CILINDROS <CylinderLabel />
        </>
      ),
    },
    {
      id: 9,
      content: "REPOSIÇÃO",
      width: 1,
      textAlign: "center"
    },
  ];

  return (
    <Table.Header>
      <Table.Row className="h-table">
        {columns.map(col => (
          <Table.HeaderCell key={col.id} width={col.width} textAlign={col.textAlign}>
            {col.content}
          </Table.HeaderCell>
        ))}

        {!isSalvusUser && <Table.HeaderCell collapsing />}
      </Table.Row>
    </Table.Header>
  );
};

export default MonitorTableHeader;
